<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "FieldsetShort" });
import { SelectCountry } from "../../../index.js";
import { Button } from "../../../../../elements/index.js";
export let address = {};
export let showCancel = false;
export let onCancel = () => {
};
</script>

<div class = 's8-address-row'>
    <div class = 's8-country'>
        <SelectCountry bind:key = { address.countryCode }/>
    </div>

    <div class = 's8-buttons'>
        <Button
            type = 'submit'
            size = 'sm'
            label = 'Save'
            color = 'primary'
        />

        {#if showCancel }
            <span>or</span>
            <Button
                type = 'button'
                size = 'sm'
                label = 'Cancel'
                color = 'neutral'
                on:click = { onCancel }
            />
        {/if}
    </div>
</div>

<style>

    div.s8-address-row {
        display: flex;
        align-items: center;
        gap: 15px;
    }

        div.s8-address-row div.s8-country {
            flex: 1;
        }

        div.s8-address-row div.s8-buttons {
            display: flex;
            align-items: center;
            -moz-column-gap: 10px;
                 column-gap: 10px;
            margin-bottom: 11px;
        }</style>